export * from './app-footer.component';



// WEBPACK FOOTER //
// ./src/app/components/app-footer/index.ts